import React from 'react';

import Styled from './DownloadLink.styles';

type Props = {
  children: React.ReactNode;
  download: string;
  href: string;
};
const DownloadLink: React.FC<Props> = (props: Props) => {
  const {
    download,
    href,
    children,
  } = props;

  return (
    <Styled.DownloadLink href={href} download={download}>
      {children}
    </Styled.DownloadLink>
  );
};

export default DownloadLink;
